import { Component } from '@angular/core';
import { NzMessageService } from 'ng-zorro-antd/message';

import { HttpErrorResponse } from '@angular/common/http';

import { PendoAnalytics } from '@app/services/pendo-analytics';
import { FleetCardsDataService } from '@app/services/fleet-cards-data';
import { StatsigService } from '@services/statsig.service';

import { HTTP_STATUS_CODE } from '@services/server-api';

import 'style-loader!./tos-modal.component.deep.scss';

@Component({
  selector: 'tos-modal',
  templateUrl: './tos-modal.component.html',
  styleUrls: ['./tos-modal.component.scss'],
})
export class TosModalComponent {
  public isVisible: boolean;
  public hideRemindMeLater: boolean;
  public tosConfig: any;
  public remainingDismissCount: number;
  public dismissCount: number;

  constructor(
      private pendo: PendoAnalytics,
      private fleetCardsDataService: FleetCardsDataService,
      private statsigService: StatsigService,
      private message: NzMessageService,
  ) {
    this.pendo.trackEvent('Fleetcard - Terms of Service - Exposure - Modal', {});
    this.tosConfig = this.statsigService.evaluateDynamicConfig('fleetcard-tos-config').value;
    this.dismissCount = Number(localStorage.getItem('fleetcardTOSDismissalCount') || 0);
    this.hideRemindMeLater = this.dismissCount >= this.tosConfig.maxDismissalCount;
    this.remainingDismissCount = this.tosConfig.maxDismissalCount - this.dismissCount;
  }

  public show(): void {
    this.isVisible = true;
  }

  public close(): void {
    this.isVisible = false;
  }

  public remindMeLater(): void {
    const tosDismissalCount: number = Number(localStorage.getItem('fleetcardTOSDismissalCount') || 0);
    localStorage.setItem('fleetcardTOSDismissalCount', (tosDismissalCount + 1).toString());

    const nextDisplayDate: Date = new Date();
    nextDisplayDate.setDate(nextDisplayDate.getDate() + 1);
    localStorage.setItem('fleetcardTOSNextDisplayDate', nextDisplayDate.toISOString());

    this.pendo.trackEvent('Fleetcard - Terms of Service - Click - Remind me later', {});
    this.close();
  }

  public submit(): void {
    this.fleetCardsDataService.updateCCMDTermsOfService()
      .subscribe({ next: this.handleSuccessResponse.bind(this), error: this.handleErrorResponse.bind(this) });
  }

  private handleSuccessResponse(): void {
    this.pendo.trackEvent('Fleetcard - Terms of Service - Click - I accept', {});
    this.message.success($localize`Thank you. We’ve received your acknowledgment.`);
    this.fleetCardsDataService.notifyTosSubmitSuccess();
    this.close();
  }

  private handleErrorResponse(error: HttpErrorResponse): void {
    if (error.status === HTTP_STATUS_CODE.TooManyRequests) {
      this.handleSuccessResponse();
    } else {
      this.message.error($localize`Something went wrong.`);
      this.close();
    }
  }
}
